
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

interface AuthPendingViewProps {
  onAuthenticate: () => Promise<void>;
  loading: boolean;
}

const AuthPendingView = ({ onAuthenticate, loading }: AuthPendingViewProps) => {
  const navigate = useNavigate();

  const handleClick = async () => {
    if (!loading) {
      await onAuthenticate();
    }
  };

  return (
    <>
      <div className="text-center mb-6">
        {loading ? (
          <>
            <div className="flex justify-center mb-4">
              <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-eo-blue"></div>
            </div>
            <p className="text-sm text-muted-foreground mt-2">
              Completing your authentication... Please wait.
            </p>
          </>
        ) : (
          <p className="text-sm text-muted-foreground mt-2">
            Click the button below to complete your authentication
          </p>
        )}
      </div>

      {!loading && (
        <Button 
          onClick={handleClick}
          className="w-full"
        >
          Complete Authentication
        </Button>
      )}

      <div className="text-center mt-4">
        <Button
          variant="ghost"
          onClick={() => navigate('/auth')}
          className="text-sm"
        >
          Back to Sign In
        </Button>
      </div>
    </>
  );
};

export default AuthPendingView;
